import {Visibility, VisibilityOff} from '@mui/icons-material'
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Step,
  StepLabel,
  Stepper,
} from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import {accessImg} from 'assets/imageDeclear'
import Timer from 'pages/certification/modules/Timer'
import Logo from 'pages/join/images/meterarium_new_logo.gif'
import React, {useEffect, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {passwordChangeRequest} from 'utils/apiCalling/api'
import {resultAlert} from 'utils/CustomAlert/Alert'
import {hashPasswordParser} from 'utils/func/justUtils'
import {isPw} from 'utils/validation/validation'

const PasswordReset = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const {data, info} = location?.state || {}

  const steps = ['인증', '비밀번호 초기화']
  const [passInfo, setPassInfo] = useState<any>({
    password: '',
    passwordCheck: '',
    showPassword: false,
  })
  const [error, setError] = useState<boolean>(false)
  const [abnormalAccess, setaAbnormalAccess] = useState<boolean>(false)

  const passwordValidation = (e: any, type: string) => {
    const {value} = e.target
    if (isPw(value)) {
      setPassInfo({...passInfo, [type]: value})
    }
  }
  const handleClickShowPassword = () => {
    setPassInfo({...passInfo, showPassword: !passInfo.showPassword})
  }
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }
  const changeRequest = async () => {
    const parsingPassword = await hashPasswordParser(info.id, passInfo.password)
    const postData = {
      id: info.id,
      password: parsingPassword,
      token: data.token,
    }
    passwordChangeRequest(postData, {
      success: async (res: any) => {
        await resultAlert(res)
        if (res.resultCode === 0) {
          navigate('/auth', {replace: true})
        } else {
          setError(true)
        }
      },
      fail: async (e: any) => {
        await resultAlert({resultCode: e.response.status})
        setError(true)
      },
    })
  }
  useEffect(() => {
    if (!data || !info) {
      setaAbnormalAccess(true)
    }
  }, [data, info])

  return (
    <div className={'join-body w-full min-h-screen relative p-3'}>
      {/* 로고 */}
      <div className={'flex justify-center m-6 md:m-10'}>
        <img
          src={Logo}
          alt={'logo'}
          className={'w-full max-w-xs md:max-w-[700px]'}
          style={{borderRadius: '28px'}}
        />
      </div>

      {!abnormalAccess ? (
        <div className={'w-full flex justify-center px-2 md:px-0'}>
          <Paper elevation={3} className={'p-6 md:p-10 w-full md:w-1/2'}>
            <Box sx={{width: '100%'}} className={'my-7'}>
              <Stepper activeStep={1} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>

            <div className={'text-center mb-5'}>
              <span className={'font-bold'}>
                비밀번호 초기화는 <strong className={'text-red-500'}>5분 이내 </strong>
                진행되어야 합니다.
              </span>
            </div>

            <div className={'w-full flex justify-center mb-6'}>
              <Timer />
            </div>

            <div className={'flex flex-col md:flex-row gap-5 px-2 md:px-[100px]'}>
              <FormControl variant='outlined' fullWidth>
                <InputLabel htmlFor='standard-adornment-password'>비밀번호</InputLabel>
                <OutlinedInput
                  id='outlined-adornment-password'
                  type={passInfo.showPassword ? 'text' : 'password'}
                  defaultValue={passInfo.password}
                  name={'password'}
                  onChange={(e: any) => passwordValidation(e, 'password')}
                  endAdornment={
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='toggle password visibility'
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge='end'
                      >
                        {passInfo.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label='비밀번호'
                  onKeyDown={(e: any) => {
                    if (passInfo.password === '' || passInfo.passwordCheck === '') return
                    if (e.key === 'Enter') changeRequest()
                  }}
                />
              </FormControl>
              <FormControl variant='outlined' fullWidth>
                <InputLabel htmlFor='standard-adornment-checkPassword'>비밀번호 확인</InputLabel>
                <OutlinedInput
                  id='outlined-adornment-checkPassword'
                  type={passInfo.showPassword ? 'text' : 'password'}
                  defaultValue={passInfo.checkPassword}
                  name={'passwordCheck'}
                  onChange={(e: any) => passwordValidation(e, 'passwordCheck')}
                  endAdornment={
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='toggle password visibility'
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge='end'
                      >
                        {passInfo.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label='비밀번호 확인'
                  onKeyDown={(e: any) => {
                    if (passInfo.password === '' || passInfo.passwordCheck === '') return
                    if (e.key === 'Enter') changeRequest()
                  }}
                />
              </FormControl>
            </div>

            {passInfo.password !== passInfo.passwordCheck && (
              <div className={'px-2 md:px-[100px] mt-2'}>
                <span className={'text-red-500 font-extrabold'}>비밀번호가 일치하지 않습니다.</span>
              </div>
            )}

            <div className={'my-4 px-2 md:px-[100px]'}>
              <span className={'text-blue-600 font-extrabold block'}>
                비밀번호는 4자리 이상의 영문 대소문자, 숫자, 특수문자(!@#$%^&*)로 구성
              </span>
              <span className={'text-blue-600 font-extrabold block'}>
                특수문자는 !@#$%^&* 만 허용
              </span>
            </div>

            <div className={'flex gap-4 justify-end pr-2 md:pr-[70px] mb-4'}>
              <Link to={'/auth'}>
                <Button variant={'outlined'} color={'error'}>
                  로그인 페이지이동
                </Button>
              </Link>
              <Button
                variant={'contained'}
                color={'primary'}
                onClick={() => changeRequest()}
                disabled={passInfo.password === '' || passInfo.passwordCheck === ''}
              >
                비밀번호 재설정
              </Button>
            </div>

            {error && (
              <div className={'my-4 border rounded border-gray-400 p-3'}>
                <span className={'text-red-500 font-extrabold block'}>
                  비밀번호 재설정에 실패하였습니다.
                </span>
                <span className={'text-red-500 font-extrabold block'}>
                  비밀번호 재설정 시간이 초과되었거나, 잘못된 접근입니다.
                </span>
                <span className={'text-red-500 font-extrabold block'}>
                  반복적으로 비밀번호 재설정에 실패할 경우, 영아이티로 문의부탁드립니다.
                </span>
              </div>
            )}
          </Paper>
        </div>
      ) : (
        <div className={'text-center'}>
          <h2 className={'text-red-500 font-extrabold text-center'}>비정상적인 접근입니다.</h2>
          <img
            src={accessImg}
            alt={'abnormal'}
            className={'w-full md:w-2/5 mx-auto'}
            style={{borderRadius: '28px'}}
          />
          <div className={'flex justify-center mt-5'}>
            <Button
              variant={'contained'}
              color={'primary'}
              onClick={() => navigate('/auth', {replace: true})}
            >
              미터리움 이동
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default PasswordReset
